import React from "react";
import { getCheapestVariantDetails } from "../utils/productPricing";

export default function ProductCard({ product }) {
  const formatPrice = (amount) => {
    const parsedAmount = Number(amount);
    if (!Number.isFinite(parsedAmount)) {
      return "";
    }

    return new Intl.NumberFormat("sr-RS", { minimumFractionDigits: 2 })
      .format(parsedAmount / 100)
      .replace(/\s/g, "");
  };

  const { price, title, variant, hasPrice } = getCheapestVariantDetails(product);

  const handleItemSelect = () => {
    const item = {
      item_id: product.id,
      item_name: product.title,
      affiliation: "DURO",
      index: 0,
      item_brand: product?.collection?.title,
      item_category: product?.categories?.[0]?.name,
      item_list_id: "related_products",
      item_list_name: "Related products",
      item_variant: title,
      location_id: "",
      quantity: variant?.inventory_quantity,
    };

    if (hasPrice) {
      item.price = price;
    }

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "select_item",
      ecommerce: {
        item_list_id: "related_products",
        item_list_name: "Related products",
        items: [item],
      },
    });
  };

  return (
    <div className="product-card">
      <a
        onClick={handleItemSelect}
        href={`https://shop.parfimerija-duro.me/me/products/${product?.handle}`}
        className="card-link"
      >
        <div className="image-wrapper">
          <img
            src={product.thumbnail}
            className="product-image"
            alt={product.title}
          />
          <div className="overlay">
            <i className="fa fa fa-shopping-cart cart-icon"></i>
          </div>
        </div>
        <div className="info-section">
          <p className="collection-text"></p>
          <p className="product-title">{product.title}</p>
          <p className="product-collection">
            {product?.collection?.title}
            {title ? ` | ${title}` : ""}
          </p>
          {hasPrice ? (
            <p className="product-price">{formatPrice(price)} €</p>
          ) : null}
        </div>
      </a>
    </div>
  );
}
